import { ComponentProps } from 'react';
import styled from 'styled-components';

interface SkeletonProps extends ComponentProps<'div'> {
  width?: string;
  height?: string;
  borderRadius?: string;
  testId?: string;
}

const StyledSkeleton = styled.div<{
  $width: string;
  $height: string;
  $borderRadius: string;
}>`
  min-height: 1rem;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius};`}
  display: block;
  background: lightgray;
  position: relative;
  overflow: hidden;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 80%
    );
    animation: shine 2.5s infinite;
    content: '';
  }

  @keyframes shine {
    to {
      transform: translateX(100%);
    }
  }
`;

export const Skeleton = ({
  className,
  width = '100%',
  height = '100%',
  borderRadius = '',
  testId,
}: SkeletonProps) => (
  <StyledSkeleton
    data-testid={testId}
    className={className}
    $width={width}
    $height={height}
    $borderRadius={borderRadius}
  />
);

export default Skeleton;
